<div *ngIf="isSpinnerActive" class="verify-mfa-phone-spinner-block">
    <mat-progress-bar mode="indeterminate" [color]="'primary'"></mat-progress-bar>
</div>

<ngc-input-phone *ngIf="activeView === SMS_MFA_DIALOG_VIEWS.InputPhone"
                  [phone]="phone"
                  [isSpinnerActive]="isSpinnerActive"
                  [formGroup]="formGroup"
                  (cancel)="onCancel()"
                  (sendCode)="sendUserVerificationCode()"
>
</ngc-input-phone>

<ngc-verify-phone *ngIf="activeView === SMS_MFA_DIALOG_VIEWS.VerifyPhone"
                  [phone]="phone"
                  [disableResendCodeBtnTimer]="disableResendCodeBtnTimer"
                  [isSpinnerActive]="isSpinnerActive"
                  [formGroup]="formGroup"
                  (cancel)="onCancel()"
                  (sendCodeAgain)="onSendCodeAgain()"
                  (verifyCode)="onVerifyCode()"
>
</ngc-verify-phone>

<ngc-recovery-codes *ngIf="activeView === SMS_MFA_DIALOG_VIEWS.RecoveryCodes"
                    [recoveryCodes]="recoveryCodes"
                    [recoveryCodesHaveToBeSaved]="true"
                    (closeRecoveryCodes)="onCloseRecoveryCodes()"
                    (download)="onDownload()"
>
</ngc-recovery-codes>

<ngc-verify-password *ngIf="activeView === SMS_MFA_DIALOG_VIEWS.VerifyPassword"
                     [formGroup]="formGroup"
                     [isSpinnerActive]="isSpinnerActive"
                     (cancel)="onCancel()"
                     (verifyPassword)="onVerifyPassword()"
>
</ngc-verify-password>
